// VISIT FREQUENCY
export const SET_CROSS_PATIENT_HIS = 'HopeGlobalContext.SET_CROSS_PATIENT_HIS';
export const SET_HOPE_DETAIL = 'HopeGlobalContext.SET_HOPE_DETAIL';
export const SET_CROSS_PATIENT_HOPE = 'HopeGlobalContext.SET_CROSS_PATIENT_HOPE';
export const SET_AVAILABLE_ACTIONS = 'HopeGlobalContext.SET_AVAILABLE_ACTIONS';
export const SET_AVAILABLE_MILESTONES_RES = 'HopeGlobalContext.SET_AVAILABLE_MILESTONES_RES';
export const SET_HOPE_MILESTONE_STATE = 'HopeGlobalContext.SET_HOPE_MILESTONE_STATE';
export const SET_HOPE_VISIT_PROMPT_DISPLAY = 'HopeGlobalContext.SET_HOPE_VISIT_PROMPT_DISPLAY';
export const SET_CAN_SUBMIT_HOPE_VISIT = 'HopeGlobalContext.SET_CAN_SUBMIT_HOPE_VISIT';
export const SET_IS_HOPE_VISIT = 'HopeGlobalContext.SET_IS_HOPE_VISIT';
export const UPDATE_SIA_DATA = 'HopeGlobalContext.UPDATE_SIA_DATA';
export const SET_VISIT_REQUIRES_SFV = 'HopeGlobalContext.VISIT_REQUIRES_SFV';
export const SET_SIA_TEXT = 'HopeGlobalContext.SET_SIA_TEXT';
export const SET_FETCHING = 'HopeGlobalContext.SET_FETCHING';
export const SET_SIA_DISPLAY = 'HopeGlobalContext.SET_SIA_DISPLAY';
export const SET_NON_USER_IN_PROG_HOPE_VISIT = 'HopeGlobalContext.SET_NON_USER_IN_PROG_HOPE_VISIT';
export const SET_HOPE_VISIT_ATTRIBUTES_SAVED = 'HopeGlobalContext.SET_HOPE_VISIT_ATTRIBUTES_SAVED';
export const SET_HOPE_MISSING_DOCUMENTATION = 'HopeGlobalContext.SET_HOPE_MISSING_DOCUMENTATION';
export const SET_HOPE_MISSING_SIA = 'HopeGlobalContext.SET_HOPE_MISSING_SIA';
export const SET_HOPE_VALIDATION_PENDING = 'HopeGlobalContext.SET_HOPE_VALIDATION_PENDING';